interface Props {
  name: string;
  children: React.ReactNode;
}

const ThemeButton = ({ name, children }: Props) => {
  return (
    <div className="flex flex-col items-center gap-1">
      {children}
      <span className="font-mono text-[10px] leading-4 font-normal tracking-normal">{name}</span>
    </div>
  );
};

export default ThemeButton;
